(() => {
  const url = new URL(location.href);
  // Apply the default only to a fresh collection visit; preserve explicit browsing choices.
  const hasChoice = [...url.searchParams.keys()].some(key => key.startsWith('filter.') || key === 'sort_by' || key === 'page');
  if (!hasChoice && !window.Shopify?.designMode) {
    url.searchParams.set('filter.v.availability', '1');
    location.replace(url.href);
    return;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-stock-mode]');
    if (!link) return;
    const destination = new URL(location.href);
    destination.searchParams.delete('page');
    destination.searchParams.delete('filter.v.availability');
    const mode = link.dataset.stockMode;
    if (mode === 'all') {
      destination.searchParams.append('filter.v.availability', '1');
      destination.searchParams.append('filter.v.availability', '0');
    } else destination.searchParams.set('filter.v.availability', mode);
    link.href = destination.href;
  }, true);
})();